/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Flags Scheduling API
 * This page documents how to use Optimizely Flags Scheduling API. These APIs allow you to turn a flag on/off, turn a  rule on/off, change the traffic allocation of a rule and change the audience conditions of a rule. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Approval,
    ApprovalFromJSON,
    ApprovalFromJSONTyped,
    ApprovalToJSON,
    UrlList,
    UrlListFromJSON,
    UrlListFromJSONTyped,
    UrlListToJSON,
} from './';

/**
 * 
 * @export
 * @interface Approvals
 */
export interface Approvals {
    /**
     * List of Approvals.
     * @type {Array<Approval>}
     * @memberof Approvals
     */
    items: Array<Approval>;
    /**
     * Total number of approvals.
     * @type {number}
     * @memberof Approvals
     */
    total_count: number;
    /**
     * Number of Approvals on the current page.
     * @type {number}
     * @memberof Approvals
     */
    count: number;
    /**
     * Boolean indicating if there are more approvals available.
     * @type {boolean}
     * @memberof Approvals
     */
    has_more?: boolean;
    /**
     * Current page number (1-based index).
     * @type {number}
     * @memberof Approvals
     */
    page: number;
    /**
     * Total number of pages.
     * @type {number}
     * @memberof Approvals
     */
    total_pages: number;
    /**
     * Link to the first page of approvals.
     * @type {string}
     * @memberof Approvals
     */
    first_url: string;
    /**
     * Link to the last page of approvals.
     * @type {string}
     * @memberof Approvals
     */
    last_url: string;
    /**
     * List of links to the next pages of approvals in a series.
     * @type {UrlList}
     * @memberof Approvals
     */
    next_url?: UrlList;
    /**
     * List of links to previous pages of approvals in a series.
     * @type {UrlList}
     * @memberof Approvals
     */
    prev_url?: UrlList;
}

export function ApprovalsFromJSON(json: any): Approvals {
    return ApprovalsFromJSONTyped(json, false);
}

export function ApprovalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Approvals {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ApprovalFromJSON)),
        'total_count': json['total_count'],
        'count': json['count'],
        'has_more': !exists(json, 'has_more') ? undefined : json['has_more'],
        'page': json['page'],
        'total_pages': json['total_pages'],
        'first_url': json['first_url'],
        'last_url': json['last_url'],
        'next_url': !exists(json, 'next_url') ? undefined : UrlListFromJSON(json['next_url']),
        'prev_url': !exists(json, 'prev_url') ? undefined : UrlListFromJSON(json['prev_url']),
    };
}

export function ApprovalsToJSON(value?: Approvals | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ApprovalToJSON)),
        'total_count': value.total_count,
        'count': value.count,
        'has_more': value.has_more,
        'page': value.page,
        'total_pages': value.total_pages,
        'first_url': value.first_url,
        'last_url': value.last_url,
        'next_url': UrlListToJSON(value.next_url),
        'prev_url': UrlListToJSON(value.prev_url),
    };
}


